import React from 'react';
import {domain} from '../../../Auth/Config'
const withdrawRequestUrl = domain + '/wp-json/freespin/v1/withdraw';
const withdrawCommentsListUrl = domain + '/wp-json/freespin/v1/withdrawcomments';
export {withdrawRequestUrl, withdrawCommentsListUrl};